import { KeywordRowActions } from 'modules/cms/seo/keyword/components/KeywordRowActions';
import { CellAlign, HeadCell } from '@dfl/mui-admin-layout';
import { IKeyword, KEYWORD_PRIORITY_ENUM } from 'modules/cms/seo/keyword/interfaces';
import { KEYWORD_PERMISSIONS } from 'modules/cms/seo/keyword/constants/keyword.permissions';
import KeywordPriorityPicker from '../components/KeywordPriorityPicker/KeywordPriorityPicker';
import { Stack, Tooltip } from '@mui/material';
import { HelpOutlineOutlined } from '@mui/icons-material';

export const keywordNameColumn: HeadCell<IKeyword> = {
  field: 'title',
  headerName: 'keyword:fields.title',
  disablePadding: false,
};

export const keywordDensityColumn: HeadCell<IKeyword> = {
  field: 'density',
  headerName: 'keyword:fields.density',
  align: CellAlign.CENTER,
  width: 200,
  renderHeader: (value: string, t: any) => <DensityHeadCell {...{ value, t }} />,
};

export const keywordPriorityColumn: HeadCell<IKeyword> = {
  field: 'priority',
  width: 200,
  headerName: 'keyword:fields.priority',
  align: CellAlign.CENTER,
  renderCell: (priority: KEYWORD_PRIORITY_ENUM, keyword: IKeyword) => (
    <KeywordPriorityPicker keywordId={keyword?._id as string} value={priority} />
  ),
};

export const keywordActionsColumn: HeadCell<IKeyword> = {
  field: 'actions',
  sortable: false,
  width: 150,
  permissions: KEYWORD_PERMISSIONS.KEYWORD_WRITE,
  headerName: 'common:actions',
  disablePadding: true,
  component: KeywordRowActions,
  align: CellAlign.CENTER,
};

export const keywordColumns: Array<HeadCell<any>> = [
  keywordNameColumn,
  keywordDensityColumn,
  keywordPriorityColumn,
  keywordActionsColumn,
];

const DensityHeadCell = ({ value, t }: { value: string; t: any }) => {
  return (
    <Stack sx={{ flexDirection: 'row', gap: 1, alignItems: 'center' }}>
      {t(`keyword:fields.${value}`)}
      <Tooltip title={t('keyword:fields.densityNote')} placement='top' arrow>
        <HelpOutlineOutlined fontSize='small' />
      </Tooltip>
    </Stack>
  );
};
